import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/sales',
    children: [
      { path: '', redirect: '/sales/home' },
      { path: 'home', name: 'sales-home', component: () => import('@/modules/sales/SalesHome.vue') },
      { path: 'customers', name: 'sales-customers', component: () => import('@/modules/sales/CustomerList.vue') },
      { path: 'customer-new', name: 'sales-customer-new', component: () => import('@/modules/sales/CustomerCreate.vue') },
      { path: 'customer/:id', name: 'sales-customer-detail', component: () => import('@/modules/sales/CustomerDetail.vue') },
      { path: 'orders', name: 'sales-orders', component: () => import('@/modules/sales/SalesOrderList.vue') },
      { path: 'order/:id', name: 'sales-order-detail', component: () => import('@/modules/sales/CustomerDetail.vue') },
      { path: 'quotations', name: 'sales-quotations', component: () => import('@/modules/sales/QuotationList.vue') },
      { path: 'quotation-new', name: 'sales-quotation-new', component: () => import('@/modules/sales/SalesHome.vue') },
      { path: 'contracts', name: 'sales-contracts', component: () => import('@/modules/sales/QuotationList.vue') },
      { path: 'ai-quote', name: 'sales-ai-quote', component: () => import('@/modules/sales/AiQuoteWizard.vue') },
      { path: '360/:id?', name: 'sales-customer-360', component: () => import('@/modules/sales/CustomerCenter360.vue') }
    ]
  }
]

export default routes
